export const configHimawariDhFdIrht = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_sat_url%/JMA_OBS_HIMA8_FD_CLDTOP/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "JMA_OBS_HIMA8_FD_CLDTOP",
      "url": "%expo_tile_sat_url%/JMA_OBS_HIMA8_FD_CLDTOP_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 0,
        "MaxZoom": 6,
        "YCoordinate": -1
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const configHimawariDhJpIrht = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_sat_url%/JMA_OBS_HIMA8_JP_CLDTOP/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "JMA_OBS_HIMA8_JP_CLDTOP",
      "url": "%expo_tile_sat_url%/JMA_OBS_HIMA8_JP_CLDTOP_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 0,
        "MaxZoom": 6,
        "YCoordinate": -1
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configHimawariDhFdIrtp = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_sat_url%/JMA_OBS_HIMA8_FD_IR/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "JMA_OBS_HIMA8_FD_IR",
      "url": "%expo_tile_sat_url%/JMA_OBS_HIMA8_FD_IR_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 0,
        "MaxZoom": 6,
        "YCoordinate": -1
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const configHimawariDhJpIrtp = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_sat_url%/JMA_OBS_HIMA8_JP_IR/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "JMA_OBS_HIMA8_JP_IR",
      "url": "%expo_tile_sat_url%/JMA_OBS_HIMA8_JP_IR_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 0,
        "MaxZoom": 6,
        "YCoordinate": -1
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configHimawariDhFdWv = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_sat_url%/JMA_OBS_HIMA8_FD_WV/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "JMA_OBS_HIMA8_FD_WV",
      "url": "%expo_tile_sat_url%/JMA_OBS_HIMA8_FD_WV_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 0,
        "MaxZoom": 6,
        "YCoordinate": -1
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const configHimawariDhJpWv = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_sat_url%/JMA_OBS_HIMA8_JP_WV/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "JMA_OBS_HIMA8_JP_WV",
      "url": "%expo_tile_sat_url%/JMA_OBS_HIMA8_JP_WV_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 0,
        "MaxZoom": 6,
        "YCoordinate": -1
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configHimawariDhFdVis = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_sat_url%/JMA_OBS_HIMA8_FD_VIS/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "JMA_OBS_HIMA8_FD_VIS",
      "url": "%expo_tile_sat_url%/JMA_OBS_HIMA8_FD_VIS_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 0,
        "MaxZoom": 8,
        "YCoordinate": -1
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const configHimawariDhJpVis = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_sat_url%/JMA_OBS_HIMA8_JP_VIS/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "JMA_OBS_HIMA8_JP_VIS",
      "url": "%expo_tile_sat_url%/JMA_OBS_HIMA8_JP_VIS_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 0,
        "MaxZoom": 8,
        "YCoordinate": -1
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configHimawariDhFdVws = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_ANLSIS_HIMA8_VOLASH/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WNI_ANLSIS_HIMA8_VOLASH",
      "url": "%expo_tile_gpv_url%/WNI_ANLSIS_HIMA8_VOLASH_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 0,
        "MaxZoom": 6,
        "YCoordinate": -1
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configHimawariDhFdCb = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_ANLSIS_HIMA8_CB/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WNI_ANLSIS_HIMA8_CB",
      "url": "%expo_tile_gpv_url%/WNI_ANLSIS_HIMA8_CB_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 6,
        "YCoordinate": -1
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const configHimawariDhFdCbDev = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_ANLSIS_HIMA8_CB_DEVLOP/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WNI_ANLSIS_HIMA8_CB_DEVLOP",
      "url": "%expo_tile_gpv_url%/WNI_ANLSIS_HIMA8_CB_DEVLOP_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 6,
        "YCoordinate": -1
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};
export const configHimawariDhFdIrDiff = {
  "Controller": {
    "Name": "EXPO_Tile"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "url": "%expo_tile_gpv_url%/WNI_ANLSIS_HIMA8_IRDIFF/list",
      "cache_busting": true
    },
    "data": {
      "Type": "TMS",
      "Name": "WNI_ANLSIS_HIMA8_IRDIFF",
      "url": "%expo_tile_gpv_url%/WNI_ANLSIS_HIMA8_IRDIFF_%validtime%/%z%_%y%_%x%.png",
      "cache": true,
      "download_max": 32,
      "Grid": {
        "MinZoom": 1,
        "MaxZoom": 6,
        "YCoordinate": -1
      }
    },
    "validtime": {
      "Type": "Derived",
      "retain": true,
      "update_interval": 60
    }
  }
};

export const configHimawariLayerIrht = {
  "Name": "HimawariFDIRHT",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "palette": [
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 3],
          [255, 255, 255, 3],
          [255, 255, 255, 6],
          [255, 255, 255, 6],
          [255, 255, 255, 6],
          [255, 255, 255, 9],
          [255, 255, 255, 9],
          [255, 255, 255, 9],
          [255, 255, 255, 13],
          [255, 255, 255, 13],
          [255, 255, 255, 13],
          [255, 255, 255, 16],
          [255, 255, 255, 16],
          [255, 255, 255, 19],
          [255, 255, 255, 19],
          [255, 255, 255, 19],
          [255, 255, 255, 23],
          [255, 255, 255, 23],
          [255, 255, 255, 23],
          [255, 255, 255, 26],
          [255, 255, 255, 26],
          [255, 255, 255, 26],
          [255, 255, 255, 29],
          [255, 255, 255, 29],
          [255, 255, 255, 33],
          [255, 255, 255, 33],
          [255, 255, 255, 33],
          [255, 255, 255, 36],
          [255, 255, 255, 36],
          [255, 255, 255, 36],
          [255, 255, 255, 39],
          [255, 255, 255, 39],
          [255, 255, 255, 39],
          [255, 255, 255, 43],
          [255, 255, 255, 43],
          [255, 255, 255, 46],
          [255, 255, 255, 46],
          [255, 255, 255, 46],
          [255, 255, 255, 49],
          [255, 255, 255, 49],
          [255, 255, 255, 49],
          [255, 255, 255, 53],
          [255, 255, 255, 53],
          [255, 255, 255, 53],
          [255, 255, 255, 56],
          [255, 255, 255, 56],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 63],
          [255, 255, 255, 63],
          [255, 255, 255, 63],
          [255, 255, 255, 66],
          [255, 255, 255, 66],
          [255, 255, 255, 66],
          [255, 255, 255, 69],
          [255, 255, 255, 69],
          [255, 255, 255, 73],
          [255, 255, 255, 73],
          [255, 255, 255, 73],
          [255, 255, 255, 76],
          [255, 255, 255, 76],
          [255, 255, 255, 76],
          [255, 255, 255, 79],
          [255, 255, 255, 79],
          [255, 255, 255, 79],
          [255, 255, 255, 83],
          [255, 255, 255, 83],
          [255, 255, 255, 86],
          [255, 255, 255, 86],
          [255, 255, 255, 86],
          [255, 255, 255, 89],
          [255, 255, 255, 89],
          [255, 255, 255, 89],
          [255, 255, 255, 92],
          [255, 255, 255, 92],
          [255, 255, 255, 92],
          [255, 255, 255, 96],
          [255, 255, 255, 96],
          [255, 255, 255, 99],
          [255, 255, 255, 99],
          [255, 255, 255, 99],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 106],
          [255, 255, 255, 106],
          [255, 255, 255, 109],
          [255, 255, 255, 109],
          [255, 255, 255, 109],
          [255, 255, 255, 112],
          [255, 255, 255, 112],
          [255, 255, 255, 112],
          [255, 255, 255, 116],
          [255, 255, 255, 116],
          [255, 255, 255, 116],
          [255, 255, 255, 119],
          [255, 255, 255, 119],
          [255, 255, 255, 122],
          [255, 255, 255, 122],
          [255, 255, 255, 122],
          [255, 255, 255, 126],
          [255, 255, 255, 126],
          [255, 255, 255, 126],
          [255, 255, 255, 129],
          [255, 255, 255, 129],
          [255, 255, 255, 129],
          [255, 255, 255, 132],
          [255, 255, 255, 132],
          [255, 255, 255, 132],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 139],
          [255, 255, 255, 139],
          [255, 255, 255, 139],
          [255, 255, 255, 142],
          [255, 255, 255, 142],
          [255, 255, 255, 142],
          [255, 255, 255, 146],
          [255, 255, 255, 146],
          [255, 255, 255, 149],
          [255, 255, 255, 149],
          [255, 255, 255, 149],
          [255, 255, 255, 152],
          [255, 255, 255, 152],
          [255, 255, 255, 152],
          [255, 255, 255, 156],
          [255, 255, 255, 156],
          [255, 255, 255, 156],
          [255, 255, 255, 159],
          [255, 255, 255, 159],
          [255, 255, 255, 162],
          [255, 255, 255, 162],
          [255, 255, 255, 162],
          [255, 255, 255, 166],
          [255, 255, 255, 166],
          [255, 255, 255, 166],
          [255, 255, 255, 169],
          [255, 255, 255, 169],
          [255, 255, 255, 169],
          [255, 255, 255, 172],
          [255, 255, 255, 172],
          [255, 255, 255, 175],
          [255, 255, 255, 175],
          [255, 255, 255, 175],
          [255, 255, 255, 179],
          [255, 255, 255, 179],
          [255, 255, 255, 179],
          [255, 255, 255, 182],
          [255, 255, 255, 182],
          [255, 255, 255, 182],
          [255, 255, 255, 185],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153]
        ]
      },
      "monochrome": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "palette": [
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 3],
          [255, 255, 255, 3],
          [255, 255, 255, 6],
          [255, 255, 255, 6],
          [255, 255, 255, 6],
          [255, 255, 255, 9],
          [255, 255, 255, 9],
          [255, 255, 255, 9],
          [255, 255, 255, 13],
          [255, 255, 255, 13],
          [255, 255, 255, 13],
          [255, 255, 255, 16],
          [255, 255, 255, 16],
          [255, 255, 255, 19],
          [255, 255, 255, 19],
          [255, 255, 255, 19],
          [255, 255, 255, 23],
          [255, 255, 255, 23],
          [255, 255, 255, 23],
          [255, 255, 255, 26],
          [255, 255, 255, 26],
          [255, 255, 255, 26],
          [255, 255, 255, 29],
          [255, 255, 255, 29],
          [255, 255, 255, 33],
          [255, 255, 255, 33],
          [255, 255, 255, 33],
          [255, 255, 255, 36],
          [255, 255, 255, 36],
          [255, 255, 255, 36],
          [255, 255, 255, 39],
          [255, 255, 255, 39],
          [255, 255, 255, 39],
          [255, 255, 255, 43],
          [255, 255, 255, 43],
          [255, 255, 255, 46],
          [255, 255, 255, 46],
          [255, 255, 255, 46],
          [255, 255, 255, 49],
          [255, 255, 255, 49],
          [255, 255, 255, 49],
          [255, 255, 255, 53],
          [255, 255, 255, 53],
          [255, 255, 255, 53],
          [255, 255, 255, 56],
          [255, 255, 255, 56],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 63],
          [255, 255, 255, 63],
          [255, 255, 255, 63],
          [255, 255, 255, 66],
          [255, 255, 255, 66],
          [255, 255, 255, 66],
          [255, 255, 255, 69],
          [255, 255, 255, 69],
          [255, 255, 255, 73],
          [255, 255, 255, 73],
          [255, 255, 255, 73],
          [255, 255, 255, 76],
          [255, 255, 255, 76],
          [255, 255, 255, 76],
          [255, 255, 255, 79],
          [255, 255, 255, 79],
          [255, 255, 255, 79],
          [255, 255, 255, 83],
          [255, 255, 255, 83],
          [255, 255, 255, 86],
          [255, 255, 255, 86],
          [255, 255, 255, 86],
          [255, 255, 255, 89],
          [255, 255, 255, 89],
          [255, 255, 255, 89],
          [255, 255, 255, 92],
          [255, 255, 255, 92],
          [255, 255, 255, 92],
          [255, 255, 255, 96],
          [255, 255, 255, 96],
          [255, 255, 255, 99],
          [255, 255, 255, 99],
          [255, 255, 255, 99],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 106],
          [255, 255, 255, 106],
          [255, 255, 255, 109],
          [255, 255, 255, 109],
          [255, 255, 255, 109],
          [255, 255, 255, 112],
          [255, 255, 255, 112],
          [255, 255, 255, 112],
          [255, 255, 255, 116],
          [255, 255, 255, 116],
          [255, 255, 255, 116],
          [255, 255, 255, 119],
          [255, 255, 255, 119],
          [255, 255, 255, 122],
          [255, 255, 255, 122],
          [255, 255, 255, 122],
          [255, 255, 255, 126],
          [255, 255, 255, 126],
          [255, 255, 255, 126],
          [255, 255, 255, 129],
          [255, 255, 255, 129],
          [255, 255, 255, 129],
          [255, 255, 255, 132],
          [255, 255, 255, 132],
          [255, 255, 255, 132],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 139],
          [255, 255, 255, 139],
          [255, 255, 255, 139],
          [255, 255, 255, 142],
          [255, 255, 255, 142],
          [255, 255, 255, 142],
          [255, 255, 255, 146],
          [255, 255, 255, 146],
          [255, 255, 255, 149],
          [255, 255, 255, 149],
          [255, 255, 255, 149],
          [255, 255, 255, 152],
          [255, 255, 255, 152],
          [255, 255, 255, 152],
          [255, 255, 255, 156],
          [255, 255, 255, 156],
          [255, 255, 255, 156],
          [255, 255, 255, 159],
          [255, 255, 255, 159],
          [255, 255, 255, 162],
          [255, 255, 255, 162],
          [255, 255, 255, 162],
          [255, 255, 255, 166],
          [255, 255, 255, 166],
          [255, 255, 255, 166],
          [255, 255, 255, 169],
          [255, 255, 255, 169],
          [255, 255, 255, 169],
          [255, 255, 255, 172],
          [255, 255, 255, 172],
          [255, 255, 255, 175],
          [255, 255, 255, 175],
          [255, 255, 255, 175],
          [255, 255, 255, 179],
          [255, 255, 255, 179],
          [255, 255, 255, 179],
          [255, 255, 255, 182],
          [255, 255, 255, 182],
          [255, 255, 255, 182],
          [255, 255, 255, 185],
          [255, 255, 255, 185],
          [255, 255, 255, 189],
          [255, 255, 255, 189],
          [255, 255, 255, 189],
          [255, 255, 255, 192],
          [255, 255, 255, 192],
          [255, 255, 255, 192],
          [255, 255, 255, 195],
          [255, 255, 255, 195],
          [255, 255, 255, 195],
          [255, 255, 255, 199],
          [255, 255, 255, 199],
          [255, 255, 255, 202],
          [255, 255, 255, 202],
          [255, 255, 255, 202],
          [255, 255, 255, 205],
          [255, 255, 255, 205],
          [255, 255, 255, 205],
          [255, 255, 255, 209],
          [255, 255, 255, 209],
          [255, 255, 255, 212],
          [255, 255, 255, 212],
          [255, 255, 255, 212],
          [255, 255, 255, 215],
          [255, 255, 255, 215],
          [255, 255, 255, 215],
          [255, 255, 255, 219],
          [255, 255, 255, 219],
          [255, 255, 255, 219],
          [255, 255, 255, 222],
          [255, 255, 255, 222],
          [255, 255, 255, 225],
          [255, 255, 255, 225],
          [255, 255, 255, 225],
          [255, 255, 255, 229],
          [255, 255, 255, 229],
          [255, 255, 255, 229],
          [255, 255, 255, 232],
          [255, 255, 255, 232],
          [255, 255, 255, 232],
          [255, 255, 255, 235],
          [255, 255, 255, 235],
          [255, 255, 255, 239],
          [255, 255, 255, 239],
          [255, 255, 255, 239],
          [255, 255, 255, 242],
          [255, 255, 255, 242],
          [255, 255, 255, 242],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 250]
        ]
      }
    }
  }
};

export const configHimawariLayerIrtp = {
  "Name": "HimawariFDIRTP",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "palette": [
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 8],
          [255, 255, 255, 17],
          [255, 255, 255, 17],
          [255, 255, 255, 17],
          [255, 255, 255, 17],
          [255, 255, 255, 17],
          [255, 255, 255, 17],
          [255, 255, 255, 17],
          [255, 255, 255, 25],
          [255, 255, 255, 25],
          [255, 255, 255, 25],
          [255, 255, 255, 25],
          [255, 255, 255, 25],
          [255, 255, 255, 34],
          [255, 255, 255, 34],
          [255, 255, 255, 34],
          [255, 255, 255, 34],
          [255, 255, 255, 34],
          [255, 255, 255, 34],
          [255, 255, 255, 34],
          [255, 255, 255, 42],
          [255, 255, 255, 42],
          [255, 255, 255, 42],
          [255, 255, 255, 42],
          [255, 255, 255, 42],
          [255, 255, 255, 51],
          [255, 255, 255, 51],
          [255, 255, 255, 51],
          [255, 255, 255, 51],
          [255, 255, 255, 51],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 59],
          [255, 255, 255, 68],
          [255, 255, 255, 68],
          [255, 255, 255, 68],
          [255, 255, 255, 68],
          [255, 255, 255, 68],
          [255, 255, 255, 68],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 102],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [255, 255, 255, 136],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [193, 210, 87, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [255, 255, 0, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [223, 102, 102, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [212, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153],
          [0, 0, 0, 153]
        ]
      },
      "monochrome": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "palette": [
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 0],
          [255, 255, 255, 2],
          [255, 255, 255, 2],
          [255, 255, 255, 2],
          [255, 255, 255, 2],
          [255, 255, 255, 5],
          [255, 255, 255, 5],
          [255, 255, 255, 7],
          [255, 255, 255, 7],
          [255, 255, 255, 10],
          [255, 255, 255, 13],
          [255, 255, 255, 15],
          [255, 255, 255, 18],
          [255, 255, 255, 20],
          [255, 255, 255, 23],
          [255, 255, 255, 26],
          [255, 255, 255, 28],
          [255, 255, 255, 31],
          [255, 255, 255, 34],
          [255, 255, 255, 36],
          [255, 255, 255, 39],
          [255, 255, 255, 41],
          [255, 255, 255, 44],
          [255, 255, 255, 49],
          [255, 255, 255, 55],
          [255, 255, 255, 60],
          [255, 255, 255, 63],
          [255, 255, 255, 66],
          [255, 255, 255, 70],
          [255, 255, 255, 76],
          [255, 255, 255, 83],
          [255, 255, 255, 89],
          [255, 255, 255, 94],
          [255, 255, 255, 99],
          [255, 255, 255, 102],
          [255, 255, 255, 104],
          [255, 255, 255, 106],
          [255, 255, 255, 108],
          [255, 255, 255, 110],
          [255, 255, 255, 112],
          [255, 255, 255, 114],
          [255, 255, 255, 116],
          [255, 255, 255, 118],
          [255, 255, 255, 120],
          [255, 255, 255, 122],
          [255, 255, 255, 124],
          [255, 255, 255, 128],
          [255, 255, 255, 131],
          [255, 255, 255, 133],
          [255, 255, 255, 136],
          [255, 255, 255, 138],
          [255, 255, 255, 138],
          [255, 255, 255, 141],
          [255, 255, 255, 144],
          [255, 255, 255, 146],
          [255, 255, 255, 149],
          [255, 255, 255, 152],
          [255, 255, 255, 154],
          [255, 255, 255, 157],
          [255, 255, 255, 157],
          [255, 255, 255, 159],
          [255, 255, 255, 162],
          [255, 255, 255, 165],
          [255, 255, 255, 167],
          [255, 255, 255, 170],
          [255, 255, 255, 172],
          [255, 255, 255, 175],
          [255, 255, 255, 175],
          [255, 255, 255, 178],
          [255, 255, 255, 178],
          [255, 255, 255, 180],
          [255, 255, 255, 180],
          [255, 255, 255, 183],
          [255, 255, 255, 186],
          [255, 255, 255, 188],
          [255, 255, 255, 191],
          [255, 255, 255, 193],
          [255, 255, 255, 196],
          [255, 255, 255, 199],
          [255, 255, 255, 199],
          [255, 255, 255, 201],
          [255, 255, 255, 201],
          [255, 255, 255, 204],
          [255, 255, 255, 204],
          [255, 255, 255, 207],
          [255, 255, 255, 207],
          [255, 255, 255, 209],
          [255, 255, 255, 212],
          [255, 255, 255, 214],
          [255, 255, 255, 217],
          [255, 255, 255, 220],
          [255, 255, 255, 222],
          [255, 255, 255, 225],
          [255, 255, 255, 228],
          [255, 255, 255, 230],
          [255, 255, 255, 233],
          [255, 255, 255, 235],
          [255, 255, 255, 238],
          [255, 255, 255, 241],
          [255, 255, 255, 241],
          [255, 255, 255, 241],
          [255, 255, 255, 243],
          [255, 255, 255, 243],
          [255, 255, 255, 243],
          [255, 255, 255, 246],
          [255, 255, 255, 246],
          [255, 255, 255, 246],
          [255, 255, 255, 246],
          [255, 255, 255, 246],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 249],
          [255, 255, 255, 250],
          [255, 255, 255, 250],
          [255, 255, 255, 251],
          [255, 255, 255, 251],
          [255, 255, 255, 252],
          [255, 255, 255, 252],
          [255, 255, 255, 253],
          [255, 255, 255, 253],
          [255, 255, 255, 254],
          [255, 255, 255, 255]
        ]
      }
    }
  }
};

export const configHimawariLayerWv = {
  "Name": "HimawariWv",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "palette": [
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [255, 255, 255, 40],
          [255, 255, 255, 42],
          [255, 255, 255, 44],
          [255, 255, 255, 47],
          [255, 255, 255, 49],
          [255, 255, 255, 52],
          [255, 255, 255, 54],
          [255, 255, 255, 57],
          [255, 255, 255, 59],
          [255, 255, 255, 61],
          [255, 255, 255, 64],
          [255, 255, 255, 66],
          [255, 255, 255, 69],
          [255, 255, 255, 71],
          [255, 255, 255, 74],
          [255, 255, 255, 76],
          [255, 255, 255, 79],
          [255, 255, 255, 81],
          [255, 255, 255, 83],
          [255, 255, 255, 86],
          [255, 255, 255, 88],
          [255, 255, 255, 91],
          [255, 255, 255, 93],
          [255, 255, 255, 96],
          [255, 255, 255, 98],
          [255, 255, 255, 101],
          [255, 255, 255, 103],
          [255, 255, 255, 105],
          [255, 255, 255, 108],
          [255, 255, 255, 110],
          [255, 255, 255, 113],
          [255, 255, 255, 115],
          [255, 255, 255, 118],
          [255, 255, 255, 120],
          [255, 255, 255, 123],
          [255, 255, 255, 125],
          [255, 255, 255, 127],
          [255, 255, 255, 130],
          [255, 255, 255, 132],
          [255, 255, 255, 135],
          [255, 255, 255, 137],
          [255, 255, 255, 140],
          [255, 255, 255, 142],
          [255, 255, 255, 145],
          [255, 255, 255, 147],
          [255, 255, 255, 149],
          [255, 255, 255, 152],
          [255, 255, 255, 154],
          [255, 255, 255, 157],
          [255, 255, 255, 159],
          [255, 255, 255, 162],
          [255, 255, 255, 164],
          [255, 255, 255, 166],
          [255, 255, 255, 169],
          [255, 255, 255, 171],
          [255, 255, 255, 174],
          [255, 255, 255, 176],
          [255, 255, 255, 179],
          [255, 255, 255, 181],
          [255, 255, 255, 184],
          [255, 255, 255, 186],
          [255, 255, 255, 188],
          [255, 255, 255, 191],
          [255, 255, 255, 193],
          [255, 255, 255, 196],
          [255, 255, 255, 198],
          [255, 255, 255, 201],
          [255, 255, 255, 203],
          [255, 255, 255, 206],
          [255, 255, 255, 208],
          [255, 255, 255, 210],
          [255, 255, 255, 213],
          [255, 255, 255, 215],
          [255, 255, 255, 218],
          [255, 255, 255, 220],
          [255, 255, 255, 223],
          [255, 255, 255, 225],
          [255, 255, 255, 228],
          [255, 255, 255, 230],
          [255, 255, 255, 232],
          [255, 255, 255, 235],
          [255, 255, 255, 237],
          [255, 255, 255, 240],
          [255, 255, 255, 242],
          [255, 255, 255, 245],
          [255, 255, 255, 247],
          [255, 255, 255, 250],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255]
        ]
      }
    }
  }
};
export const configHimawariLayerVis = {
  "Name": "HimawariVis",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "palette": [
          [255, 255, 255, 0],
          [255, 255, 255, 2],
          [255, 255, 255, 4],
          [255, 255, 255, 6],
          [255, 255, 255, 8],
          [255, 255, 255, 10],
          [255, 255, 255, 12],
          [255, 255, 255, 14],
          [255, 255, 255, 16],
          [255, 255, 255, 18],
          [255, 255, 255, 20],
          [255, 255, 255, 22],
          [255, 255, 255, 24],
          [255, 255, 255, 26],
          [255, 255, 255, 28],
          [255, 255, 255, 30],
          [255, 255, 255, 32],
          [255, 255, 255, 34],
          [255, 255, 255, 36],
          [255, 255, 255, 38],
          [255, 255, 255, 40],
          [255, 255, 255, 42],
          [255, 255, 255, 44],
          [255, 255, 255, 46],
          [255, 255, 255, 48],
          [255, 255, 255, 50],
          [255, 255, 255, 52],
          [255, 255, 255, 54],
          [255, 255, 255, 56],
          [255, 255, 255, 58],
          [255, 255, 255, 60],
          [255, 255, 255, 62],
          [255, 255, 255, 64],
          [255, 255, 255, 66],
          [255, 255, 255, 68],
          [255, 255, 255, 70],
          [255, 255, 255, 72],
          [255, 255, 255, 74],
          [255, 255, 255, 76],
          [255, 255, 255, 78],
          [255, 255, 255, 80],
          [255, 255, 255, 82],
          [255, 255, 255, 84],
          [255, 255, 255, 86],
          [255, 255, 255, 88],
          [255, 255, 255, 90],
          [255, 255, 255, 92],
          [255, 255, 255, 94],
          [255, 255, 255, 96],
          [255, 255, 255, 98],
          [255, 255, 255, 100],
          [255, 255, 255, 102],
          [255, 255, 255, 104],
          [255, 255, 255, 106],
          [255, 255, 255, 108],
          [255, 255, 255, 110],
          [255, 255, 255, 112],
          [255, 255, 255, 114],
          [255, 255, 255, 116],
          [255, 255, 255, 118],
          [255, 255, 255, 120],
          [255, 255, 255, 122],
          [255, 255, 255, 124],
          [255, 255, 255, 126],
          [255, 255, 255, 128],
          [255, 255, 255, 130],
          [255, 255, 255, 132],
          [255, 255, 255, 134],
          [255, 255, 255, 136],
          [255, 255, 255, 138],
          [255, 255, 255, 140],
          [255, 255, 255, 142],
          [255, 255, 255, 144],
          [255, 255, 255, 146],
          [255, 255, 255, 148],
          [255, 255, 255, 150],
          [255, 255, 255, 152],
          [255, 255, 255, 154],
          [255, 255, 255, 156],
          [255, 255, 255, 158],
          [255, 255, 255, 160],
          [255, 255, 255, 162],
          [255, 255, 255, 164],
          [255, 255, 255, 166],
          [255, 255, 255, 168],
          [255, 255, 255, 170],
          [255, 255, 255, 172],
          [255, 255, 255, 174],
          [255, 255, 255, 176],
          [255, 255, 255, 178],
          [255, 255, 255, 180],
          [255, 255, 255, 182],
          [255, 255, 255, 184],
          [255, 255, 255, 186],
          [255, 255, 255, 188],
          [255, 255, 255, 190],
          [255, 255, 255, 192],
          [255, 255, 255, 194],
          [255, 255, 255, 196],
          [255, 255, 255, 198],
          [255, 255, 255, 200],
          [255, 255, 255, 202],
          [255, 255, 255, 204],
          [255, 255, 255, 206],
          [255, 255, 255, 208],
          [255, 255, 255, 210],
          [255, 255, 255, 212],
          [255, 255, 255, 214],
          [255, 255, 255, 216],
          [255, 255, 255, 218],
          [255, 255, 255, 220],
          [255, 255, 255, 222],
          [255, 255, 255, 224],
          [255, 255, 255, 226],
          [255, 255, 255, 228],
          [255, 255, 255, 230],
          [255, 255, 255, 232],
          [255, 255, 255, 234],
          [255, 255, 255, 236],
          [255, 255, 255, 238],
          [255, 255, 255, 240],
          [255, 255, 255, 242],
          [255, 255, 255, 244],
          [255, 255, 255, 246],
          [255, 255, 255, 248],
          [255, 255, 255, 250],
          [255, 255, 255, 252],
          [255, 255, 255, 254],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255],
          [255, 255, 255, 255]
        ]
      }
    }
  }
};
export const configHimawariLayerVws = {
  "Name": "HimawariVws",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "filter",
        "opacity": 1
      }
    }
  }
};
export const configHimawariLayerCb = {
  "Name": "HimawariCb",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "palette": [
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [255, 0, 0, 255],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0]
        ]
      }
    }
  }
};
export const configHimawariLayerCbDev = {
  "Name": "HimawariCbDev",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "palette": [
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 255, 0, 255],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0],
          [0, 0, 0, 0]
        ]
      }
    }
  }
};
export const configHimawariLayerIrDiff = {
  "Name": "HimawariIrDiff",
  "Renderer": "Image",
  "Attributes": {
    "style": {
      "default": {
        "type": "grayscale_palette",
        "mag_filter": "NEAREST",
        "palette": [
          [0, 0, 0, 0],
          [1, 1, 1, 204],
          [2, 2, 2, 204],
          [3, 3, 3, 204],
          [4, 4, 4, 204],
          [5, 5, 5, 204],
          [6, 6, 6, 204],
          [7, 7, 7, 204],
          [8, 8, 8, 204],
          [9, 9, 9, 204],
          [10, 10, 10, 204],
          [11, 11, 11, 204],
          [12, 12, 12, 204],
          [13, 13, 13, 204],
          [14, 14, 14, 204],
          [15, 15, 15, 204],
          [16, 16, 16, 204],
          [17, 17, 17, 204],
          [18, 18, 18, 204],
          [19, 19, 19, 204],
          [20, 20, 20, 204],
          [21, 21, 21, 204],
          [22, 22, 22, 204],
          [23, 23, 23, 204],
          [24, 24, 24, 204],
          [25, 25, 25, 204],
          [26, 26, 26, 204],
          [27, 27, 27, 204],
          [28, 28, 28, 204],
          [29, 29, 29, 204],
          [30, 30, 30, 204],
          [31, 31, 31, 204],
          [32, 32, 32, 204],
          [33, 33, 33, 204],
          [34, 34, 34, 204],
          [35, 35, 35, 204],
          [36, 36, 36, 204],
          [37, 37, 37, 204],
          [38, 38, 38, 204],
          [39, 39, 39, 204],
          [40, 40, 40, 204],
          [41, 41, 41, 204],
          [42, 42, 42, 204],
          [43, 43, 43, 204],
          [44, 44, 44, 204],
          [45, 45, 45, 204],
          [46, 46, 46, 204],
          [47, 47, 47, 204],
          [48, 48, 48, 204],
          [49, 49, 49, 204],
          [50, 50, 50, 204],
          [51, 51, 51, 204],
          [52, 52, 52, 204],
          [53, 53, 53, 204],
          [54, 54, 54, 204],
          [55, 55, 55, 204],
          [56, 56, 56, 204],
          [57, 57, 57, 204],
          [58, 58, 58, 204],
          [59, 59, 59, 204],
          [60, 60, 60, 204],
          [61, 61, 61, 204],
          [62, 62, 62, 204],
          [63, 63, 63, 204],
          [64, 64, 64, 204],
          [65, 65, 65, 204],
          [66, 66, 66, 204],
          [67, 67, 67, 204],
          [68, 68, 68, 204],
          [69, 69, 69, 204],
          [70, 70, 70, 204],
          [71, 71, 71, 204],
          [72, 72, 72, 204],
          [73, 73, 73, 204],
          [74, 74, 74, 204],
          [75, 75, 75, 204],
          [76, 76, 76, 204],
          [77, 77, 77, 204],
          [78, 78, 78, 204],
          [79, 79, 79, 204],
          [80, 80, 80, 204],
          [81, 81, 81, 204],
          [82, 82, 82, 204],
          [83, 83, 83, 204],
          [84, 84, 84, 204],
          [85, 85, 85, 204],
          [86, 86, 86, 204],
          [87, 87, 87, 204],
          [88, 88, 88, 204],
          [89, 89, 89, 204],
          [90, 90, 90, 204],
          [91, 91, 91, 204],
          [92, 92, 92, 204],
          [93, 93, 93, 204],
          [94, 94, 94, 204],
          [95, 95, 95, 204],
          [96, 96, 96, 204],
          [97, 97, 97, 204],
          [98, 98, 98, 204],
          [99, 99, 99, 204],
          [100, 100, 100, 204],
          [101, 101, 101, 204],
          [102, 102, 102, 204],
          [103, 103, 103, 204],
          [104, 104, 104, 204],
          [105, 105, 105, 204],
          [106, 106, 106, 204],
          [107, 107, 107, 204],
          [108, 108, 108, 204],
          [109, 109, 109, 204],
          [110, 110, 110, 204],
          [111, 111, 111, 204],
          [112, 112, 112, 204],
          [113, 113, 113, 204],
          [114, 114, 114, 204],
          [115, 115, 115, 204],
          [116, 116, 116, 204],
          [117, 117, 117, 204],
          [118, 118, 118, 204],
          [119, 119, 119, 204],
          [120, 120, 120, 204],
          [121, 121, 121, 204],
          [122, 122, 122, 204],
          [123, 123, 123, 204],
          [124, 124, 124, 204],
          [125, 125, 125, 204],
          [126, 126, 126, 204],
          [127, 127, 127, 204],
          [128, 128, 128, 204],
          [129, 129, 129, 204],
          [130, 130, 130, 204],
          [131, 131, 131, 204],
          [132, 132, 132, 204],
          [133, 133, 133, 204],
          [134, 134, 134, 204],
          [135, 135, 135, 204],
          [136, 136, 136, 204],
          [137, 137, 137, 204],
          [138, 138, 138, 204],
          [139, 139, 139, 204],
          [140, 140, 140, 204],
          [141, 141, 141, 204],
          [142, 142, 142, 204],
          [143, 143, 143, 204],
          [144, 144, 144, 204],
          [145, 145, 145, 204],
          [146, 146, 146, 204],
          [147, 147, 147, 204],
          [148, 148, 148, 204],
          [149, 149, 149, 204],
          [150, 150, 150, 204],
          [151, 151, 151, 204],
          [152, 152, 152, 204],
          [153, 153, 153, 204],
          [154, 154, 154, 204],
          [155, 155, 155, 204],
          [156, 156, 156, 204],
          [157, 157, 157, 204],
          [158, 158, 158, 204],
          [159, 159, 159, 204],
          [160, 160, 160, 204],
          [161, 161, 161, 204],
          [162, 162, 162, 204],
          [163, 163, 163, 204],
          [164, 164, 164, 204],
          [165, 165, 165, 204],
          [166, 166, 166, 204],
          [167, 167, 167, 204],
          [168, 168, 168, 204],
          [169, 169, 169, 204],
          [170, 170, 170, 204],
          [171, 171, 171, 204],
          [172, 172, 172, 204],
          [173, 173, 173, 204],
          [174, 174, 174, 204],
          [175, 175, 175, 204],
          [176, 176, 176, 204],
          [177, 177, 177, 204],
          [178, 178, 178, 204],
          [179, 179, 179, 204],
          [180, 180, 180, 204],
          [181, 181, 181, 204],
          [182, 182, 182, 204],
          [183, 183, 183, 204],
          [184, 184, 184, 204],
          [185, 185, 185, 204],
          [186, 186, 186, 204],
          [187, 187, 187, 204],
          [188, 188, 188, 204],
          [189, 189, 189, 204],
          [190, 190, 190, 204],
          [191, 191, 191, 204],
          [192, 192, 192, 204],
          [193, 193, 193, 204],
          [194, 194, 194, 204],
          [195, 195, 195, 204],
          [196, 196, 196, 204],
          [197, 197, 197, 204],
          [198, 198, 198, 204],
          [199, 199, 199, 204],
          [200, 200, 200, 204],
          [201, 201, 201, 204],
          [202, 202, 202, 204],
          [203, 203, 203, 204],
          [204, 204, 204, 204],
          [205, 205, 205, 204],
          [206, 206, 206, 204],
          [207, 207, 207, 204],
          [208, 208, 208, 204],
          [209, 209, 209, 204],
          [210, 210, 210, 204],
          [211, 211, 211, 204],
          [212, 212, 212, 204],
          [213, 213, 213, 204],
          [214, 214, 214, 204],
          [215, 215, 215, 204],
          [216, 216, 216, 204],
          [217, 217, 217, 204],
          [218, 218, 218, 204],
          [219, 219, 219, 204],
          [220, 220, 220, 204],
          [221, 221, 221, 204],
          [222, 222, 222, 204],
          [223, 223, 223, 204],
          [224, 224, 224, 204],
          [225, 225, 225, 204],
          [226, 226, 226, 204],
          [227, 227, 227, 204],
          [228, 228, 228, 204],
          [229, 229, 229, 204],
          [230, 230, 230, 204],
          [231, 231, 231, 204],
          [232, 232, 232, 204],
          [233, 233, 233, 204],
          [234, 234, 234, 204],
          [235, 235, 235, 204],
          [236, 236, 236, 204],
          [237, 237, 237, 204],
          [238, 238, 238, 204],
          [239, 239, 239, 204],
          [240, 240, 240, 204],
          [241, 241, 241, 204],
          [242, 242, 242, 204],
          [243, 243, 243, 204],
          [244, 244, 244, 204],
          [245, 245, 245, 204],
          [246, 246, 246, 204],
          [247, 247, 247, 204],
          [248, 248, 248, 204],
          [249, 249, 249, 204],
          [250, 250, 250, 204],
          [251, 251, 251, 204],
          [252, 252, 252, 204],
          [253, 253, 253, 204],
          [254, 254, 254, 204],
          [255, 255, 255, 204]
        ]
      }
    }
  }
};
